import { Outlet } from "react-router";
import Header from "../components/Header";

export default function MainLayout() {
  return (
    <div className="flex flex-col">
      <Header />
      <Outlet />
    </div>
  );
}
